import { Avatar, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react'
import { LogOut, Menu } from 'lucide-react'
import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setLogout } from '../../redux/reducers/authReducers' 
import { RouteConstant } from '../../routes/RouteConstant'
import { useNavigate } from 'react-router-dom'
import AvatarBorder from '../../components/AvatarBorder'
import { setToggle } from '../../redux/reducers/settingsReducers'
import { IconX } from '@tabler/icons-react'

const Header = () => {

  const user = useSelector((state) => state.auth.user);
  const toggle = useSelector(state => state.settings.toggle)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const logoutUser =()=>{
    navigate(RouteConstant.ROOT)
    dispatch(setLogout());
  }

  const menuItems = [
    {
      label:"Logout",
      icon: <LogOut size="15" />,
      color: "danger",
      onClick: logoutUser
    }
  ]

  const handleToggle = () => {
    dispatch(setToggle(!toggle));
  };

  return (
    <Fragment>
      <div className="w-full h-[70px] flex bg-white top-0 max-[768px]:bg-white items-center px-6 text-[14px]">
        <button className={`hidden max-[768px]:block ${toggle?"h-[70px] flex items-center justify-end pr-4":"h-[70px] flex items-center justify-center"}`} onClick={handleToggle}>
          {
            toggle?
            <IconX size={30} className='p-[5px] text-primary'/>:
            <Menu size={30} className='p-[5px] text-primary'/>
          }
        </button>
        <div className='flex justify-between w-full items-center'>
          <div className={`flex max-[768px]:ml-10`}>
            <img src={require('../../assets/images/logo.png')} width="40px" />
          </div>
          <Dropdown placement="bottom-start">
            <DropdownTrigger>
              <div className={`${toggle&&"max-[768px]:block"} flex  items-center gap-4 cursor-pointer`}>
                <div>
                  <p className='max-[768px]:hidden'>{user?.name}</p>
                  <p className='max-[768px]:hidden text-right'>{user?.roles[0]?.label}</p>
                </div>
                <div className='relative w-[50px] h-[50px]'>
                  <div className='absolute right-0 top-0'>
                    <AvatarBorder />
                  </div>
                  <img className='w-[50px] h-[50px] rounded-full object-cover p-[4px]' src='https://media.istockphoto.com/id/1389898125/photo/young-woman-chewing-gum-cute-iconic-character-3d-rendering.jpg?s=612x612&w=0&k=20&c=qriGPWcu_8VDPI6VGmyD0oHR80lqMnk8_AtwEPm8Guo=' size='sm' />
                </div>
              </div>
            </DropdownTrigger>
            <DropdownMenu  aria-label="User Actions" variant="flat">
              <DropdownItem key="profile" className="px-10 py-4 gap-2">
                <p className="font-bold">Signed in as {user?.name}</p>
              </DropdownItem>
              {menuItems?.map((item, index)=>(
                <DropdownItem onClick={item.onClick} key={index} startContent={item.icon} color={item.color}>
                  {item.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </Fragment>
  )
}

export default Header